import StatCard from "../../../common/statecard/StatCard";
import { FilterCardItem } from "../../../../types/common-types";

export interface LeaveStats {
  total: number;
  approved: number;
  pending: number;
  rejected: number;
}
interface StatusCardsProps {
    activeCard: string;
  setActiveCard: (id: string) => void;
  cards: FilterCardItem[];
}

const StatusCards = ({ setActiveCard, activeCard, cards }: StatusCardsProps) => {

  const handleCardClick = (
    card: FilterCardItem
  ) => {
    setActiveCard(card.id);
  };

  return (
    <div className="flex gap-3">
      {cards.map((card) => (
        <StatCard
          key={card.id}
          count={card.count}
          title={card.title}
          icon={card.icon}
          active={activeCard === card.id}
          textColor={card.textColor}
          activeColor={card.activeColor}
          className="md:max-w-[140px]"
          titleClassName="text-base"
          onClick={() => handleCardClick(card)}
        />
      ))}
    </div>
  );
};

export default StatusCards;